import { getUser } from 'api/user'
import { selectBillingAccount } from 'redux/modules/user/selectBillingAccount'

export const updateUser = () => async dispatch => {
  const user = await dispatch(getUser())
  await dispatch(selectBillingAccount(user))
}
